import { useEffect } from 'react';

export default function About() {
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="AboutPage">
            <div className='interestMsg'>
                <div className='interestMsgTitle'>
                    About This Site
                </div>
                <div className='interestMsgText'>
                    <p>A simple organisational site to organise and keep track of certain data. The site is privately owned and is maintained by a single developer</p>
                    <p>Any suggestions or bugs can be reported by <a href="mailto: s.sinkiat@outlook.sg" target='noreferrer'>mailing</a> to me.</p>
                    <p></p>
                </div>
            </div>
            <div className="aLine" />
        </div>
    );
}
